//没有请为空
let cdn = 'https://elearning.sisley-eba.com.cn';
// let cdn = '/static/oem/yjt';
let host = '/static/oem/yjt';


const config = {
  //平台名称
  platformName: '法国希思黎线上培训平台',
  suffixName:'',
  //平台code (可为空，用于贴牌标记贴牌端注册的企业信息)
  platformCode: 'yjt',
  //个人端应用名称（或小程序名称）
  userAppName: '-',
  //企业端应用名称（或小程序名称）
  entAppName: '法国希思黎线上培训平台',
  //底部版权信息 支持html
  copyright: '',
  //二维码host路径
  qRCodeHost: '',
  //是否开启商城
  includeMall: false,
  enableEntRegister: false,
  enableActivation: false,
  enableQRCodeRegistration: false,
  //是否免费课程
  freeCourse: false,
  //图片节点，规范请统一放入到项目的 static/img 下 命名请规范
  images: {
    //logo图
    logoImage: cdn + '/img/logo.jpg',
    //登陆页面图
    loginTopImage: cdn + '/img/login-top-image.jpg',
    //用户小程序码图片
    userXcxCodeImage: cdn + '/img/userXcxCodeImage.png',
    //个人端简单版本二维码（正方形）
    userXcxCodeSimpleImage:  cdn + '/img/userXcxCodeSimpleImage.png',
    //企业端小程序二维码图片
    enterpriseXcxCodeImage: cdn+'/img/enterpriseXcxCodeImage.jpg',
    //企业端简单版本二维码
    enterpriseXcxCodeSimpleImage: cdn+'/img/enterpriseXcxCodeSimpleImage.png',
    //注册-个人用户注册二维码
    registerUserQRCodeImage: cdn + '/img/registerUserQRCode.jpg',
    navTopLogo: cdn + '/img/zt-nav-top-logo2.jpg',
    //客服微信
    kfWeChat: cdn + '/img/kfWeChat.png',
  },
  files: {
    protocol: {
      //企业激活相关协议
      entActivation: [
        {
          name: '《专项保密协议书》',
          url: host + '/files/protocol/entActivation/zxbmxy.html'
        }
      ],
      userRegister: [
        {
          name: '《用户注册协议》',
          url: host + '/files/protocol/register/register.html'
        }
      ]
    }
  }
}
export default config




// WEBPACK FOOTER //
// ./src/config/oem/config_default.js